import Decimal from 'decimal.js';

/**
 * Rundet den Wert zu dem nächsten 0.5 Step.
 * Beispiel: 1.01 -> 1.5
 * @param value
 * @returns {number} gerundeter Wert
 */
export const roundUpToNextHalf = (value: number): number => {
  return Math.ceil(parseFloat(String(value)) / 0.5) * 0.5;
};

/**
 * Rundet den Wert zu dem nächsten 0.1 Step.
 * Beispiel: 1.001 -> 1.1
 * @param value
 * @returns {number} gerundeter Wert
 */
export const roundUpToFirstDecimalPlace = (value: number): number => {
  return Math.ceil(parseFloat(String(value)) / 0.1) * 0.1;
};

/*
 * Summiert mehrere Dezimalzahlen.
 * Durch Verwendung dieser Funktion sollen Fehler
 * in der Darstellung von Floats vermieden werden:
 * 0.2 + 0.4 = 0.6000000000000001 ist häufig problematisch
 *
 * @param numbers Liste von Nummern die summiert werden sollen
 * @returns die Summe der übergebenen Zahlen
 */
export const addDecimalNumbers = (numbers: number[]): number => {
  return numbers.reduce((accumulator: number, number: number): number => {
    return new Decimal(accumulator).add(new Decimal(number)).toNumber();
  });
};
